import { render, staticRenderFns } from "./BudgetAllotmentUtility.vue?vue&type=template&id=0e1bc912&scoped=true&"
import script from "./BudgetAllotmentUtility.vue?vue&type=script&lang=js&"
export * from "./BudgetAllotmentUtility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1bc912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
